var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.875 13.35c0.9 0 1.65-0.75 1.725-1.65 0-0.225-0.075-0.525-0.15-0.75l3-4.35h0.15c0.225 0 0.375 0 0.6-0.075l2.475 2.025c-0.15 0.9 0.45 1.8 1.35 1.95s1.8-0.45 1.95-1.35c0.075-0.3 0-0.675-0.15-0.975l2.925-4.05c0.9 0.075 1.725-0.6 1.875-1.5s-0.6-1.725-1.5-1.875c-0.9-0.075-1.725 0.6-1.875 1.5v0.15c0 0.225 0.075 0.45 0.15 0.675l-2.925 4.05h-0.15c-0.225 0-0.375 0-0.6 0.075l-2.475-2.025c0.15-0.9-0.45-1.8-1.35-1.95s-1.8 0.45-1.95 1.35c-0.075 0.375 0 0.675 0.15 1.05l-3 4.35h-0.15c-0.9 0-1.65 0.74997-1.65 1.65s0.675 1.725 1.575 1.725zm15.3 3.525h-16.725c-0.375 0-0.675 0.3-0.675 0.675s0.3 0.675 0.675 0.675h16.65c0.375 0 0.675-0.3 0.675-0.675s-0.225-0.675-0.6-0.675z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/statsIcon.a4835f6d844ec3166cc2304b8ebe66ce.svg";
export { ForwardRef as ReactComponent };